'use strict';

/**
 *
 * Universal function for animation sections while scrolling
 * Waypoints dependency needed
 *
 */

var UTILS = UTILS || {};

UTILS._animationedSections = function _animationedSections() {
    var animation = {
            runAnimation: function(section, animClassName) {
                const splittedAnimClassName = animClassName.split('-');

                setTimeout(function() {
                    section.classList.remove(animClassName);
                }, 1200);
                section.classList.add('animated');
                section.classList.add(splittedAnimClassName[1]);
                section.classList.add('active');

                setTimeout(function() {
                    section.classList.remove('animated');
                    section.classList.remove(splittedAnimClassName[1]);
                    section.classList.remove('active');
                }, 3500);

                // start carousel autoplay
                $(section).find('.js-owl-opacity').trigger('play.owl.autoplay', [3000]);

                $(section).find('.js-owl-slider-gallery').trigger('play.owl.autoplay', [5000]);

                if (window && (/MSIE|Trident/.test(navigator.userAgent)) && window.addEventListener) {
                    setTimeout(function() {
                        $(section).find('.js-owl-slider-gallery').trigger('refresh.owl.carousel');
                        $(section).find('.js-owl-slider-text').trigger('refresh.owl.carousel');
                    }, 1000);
                }
            }
        },
        offSetSlider = '85%',
        items,
        section,
        animationClassTable = ['animation-fadeInUp', 'animation-simpleFadeIn', 'animation-iconDraw', 'animation-doubleSlider', 'animation-headlineBg', 'animation-fullBg', 'animation-fadeInLeft', 'animation-fadeInRight', 'animation-splitAnim', 'animation-multilayer', 'animation-bgImage', 'animation-circleNav', 'animation-runWaypoint'],
        i;

    for (i = 0; i < animationClassTable.length; i++) {
        let dotClassName = `.${animationClassTable[i]}`,
            className = animationClassTable[i];

        if (document.querySelector(dotClassName)) {
            items = document.querySelectorAll(dotClassName);

            [].forEach.call(items, function(item) {

                if ( !( item.classList.contains('l-header') && item.classList.contains('bg-img') && !item.classList.contains('bg-loaded')  ) ) {

                    section = new Waypoint({
                        element: item,
                        handler: function(direction) {
                            if (direction === 'down') {
                                animation.runAnimation( item, className );
                                this.destroy();
                            }
                        },
                        offset: offSetSlider
                    });
                }
            });
        }
    }
};
